/**
 * Client-side fire-and-forget error report. Never throws; never blocks UI.
 * @param {{
 *   code: string;
 *   message: string;
 *   phase?: string;
 *   botId?: number | string | null;
 *   botName?: string | null;
 *   engine?: string | null;
 *   path?: string | null;
 *   details?: Record<string, unknown>;
 *   dedupeKey?: string | null;
 * }} payload
 */
export function reportSystemError(payload) {
  if (typeof window === "undefined") return;

  const code = String(payload?.code || "").trim();
  const message = String(payload?.message || "").trim();
  if (!code || !message) return;

  const body = {
    source: "frontend",
    phase: payload?.phase || null,
    code,
    message,
    botId: payload?.botId ?? null,
    botName: payload?.botName ?? null,
    engine: payload?.engine ?? null,
    path:
      payload?.path ||
      (typeof window !== "undefined" ? window.location.pathname : null),
    details: payload?.details && typeof payload.details === "object" ? payload.details : {},
    dedupeKey: payload?.dedupeKey ?? null,
  };

  try {
    fetch("/api/system-errors/report", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
